import { all, call, put, takeLatest } from 'redux-saga/effects';
import { actions, types } from './duck';
import { getUserDetails } from './api';
import { OK } from 'http-status-codes';


function* getUserDetailsSaga({ id }) {
    try {
  
      yield put(actions.getUserDetailsRequest());
  
      const response = yield call(getUserDetails, id);
  
      if (response.status === OK) {
        yield put(actions.getUserDetailsSuccess(response.data));
      } else {        
        yield put(actions.getUserDetailsFailure(response.statusText));
      }
    } catch (error) {
      yield put(actions.getUserDetailsFailure(error.message));
    }
  }
  


export default function* saga() {
  yield all([
    takeLatest(types.GET_USER_DETAILS, getUserDetailsSaga),
  ]);
}

